import React, { Component } from 'react';
import '../buttons.scss';
class NoButton extends Component {

    clickFunction = (type,startTime, realAnswer, automaticAnswer,timeOut,symbol, symbo2,seqtorei,quantity,total,arrangement,symbolQunatity) =>{
        if(symbol && symbo2){
            this.props.fillAnswer(type, startTime, realAnswer, automaticAnswer,timeOut,symbol,symbo2,seqtorei);
        }
        if(quantity && total && arrangement){
            this.props.fillAnswer(type, startTime, realAnswer, automaticAnswer,timeOut,quantity,total,arrangement,symbolQunatity);
        }

    }

    render() {
        const {startTime, realAnswer, automaticAnswer,timeOut,symbol, symbo2,seqtorei,quantity,total,arrangement,symbolQunatity} = {...this.props}
        return (
            <button 
                className="test-button button-No" 
                onClick = {()=>{this.clickFunction('No',startTime, realAnswer, false, timeOut, symbol, symbo2,seqtorei,quantity,total,arrangement,symbolQunatity)}}
            >არა</button>
        );
    }
}

export default NoButton;